import * as yup from "yup";


export interface IJobWorkMood {
    id?: number,
    work_Mood: string,
}

export const emptyJobWorkMood: IJobWorkMood = {
    work_Mood: "",
}

export const schema = yup.object().shape({
    work_Mood: yup.string().required("Work Mood  is required")
})